import { defaultCategoryState } from './constants';

export function selectUserPreference(state, preferenceId) {
  return state.byId[preferenceId];
}

export function selectUserCategoryPreferences(state, category) {
  return state.byCategory[category] ?? defaultCategoryState;
}

export function selectDefaultUserPreference(state, category) {
  const userPreferenceCategory = selectUserCategoryPreferences(state, category);

  return selectUserPreference(state, userPreferenceCategory.defaultId);
}

export function selectUserPreferenceList(state, category) {
  const userPreferenceCategory = selectUserCategoryPreferences(state, category);

  return userPreferenceCategory.ids.map((id) => selectUserPreference(state, id));
}

// @todo move to utils
export function memoOnce(fn) {
  let prevArgs;
  let prevResult;

  return function (...nextArgs) {
    if (!prevResult || prevArgs.length !== nextArgs.length || prevArgs.some((arg, index) => arg !== nextArgs[index])) {
      prevResult = fn.apply(this, nextArgs);
      prevArgs = nextArgs;
    }

    return prevResult;
  };
}
